
import { SVGProps } from "react";

interface NetworkIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  strokeWidth?: number;
}

export const NetworkIcon = ({ 
  size = 24, 
  strokeWidth = 2, 
  width,
  height,
  ...props 
}: NetworkIconProps) => {
  // Use explicit width/height if provided, otherwise use size
  const finalWidth = width || size;
  const finalHeight = height || size;
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={finalWidth}
      height={finalHeight}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ minWidth: finalWidth, minHeight: finalHeight }}
      {...props}
    >
      <rect width="5" height="5" x="3" y="3" rx="1" />
      <rect width="5" height="5" x="16" y="3" rx="1" />
      <rect width="5" height="5" x="3" y="16" rx="1" />
      <rect width="5" height="5" x="16" y="16" rx="1" />
      <path d="M8 8v8" />
      <path d="M16 8v8" />
      <path d="M8 12h8" />
    </svg>
  );
};
